
const component = {
  namespaced: true,
  state: {
    shortcutOpen: false,
  },
  mutations: {
    shortcutOpen(state) {
      state.shortcutOpen = !state.shortcutOpen;
    },
  },
};

export default component;



// WEBPACK FOOTER //
// ./src/store/setPage/setPage.ts